import { RECEIVE_SYSTEM_MESSAGES, DISMISS_SYSTEM_MESSAGE } from './actions';

const initialState = {
  systemMessages: {},
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_SYSTEM_MESSAGES: {
      return {
        ...state,
        systemMessages: action.systemMessages.reduce((acc, message) => {
          acc[message.id] = {
            ...message,
            ...state.systemMessages[message.id],
          };
          return acc;
        }, {}),
      };
    }
    case DISMISS_SYSTEM_MESSAGE: {
      const { systemMessageId } = action;
      return {
        ...state,
        systemMessages: {
          ...state.systemMessages,
          [systemMessageId]: {
            ...state.systemMessages[systemMessageId],
            dismissed: true,
          },
        },
      };
    }

    default: {
      return state;
    }
  }
}
